/* ============================================================
   RL Exact Fit (Hauptshop Angelrollentuning)
   Rollensuche auf den drei Klassen-Sets (APEX, EDGE, CORE Spulenlager Set).
   Vanilla JS, ohne Abhängigkeiten. Ein Custom Element: <rl-exact-fit-check>.

   Grundlage ist die Exact-Fit-Suche aus Kazemaki. Unterschiede:
   - Datenquelle sind die Rollenmodelle des Hauptshops (sections/rl-exact-fit-data.liquid).
     Anzeigename, Größen-Zeile, Größe/Kurbelseite/Übersetzung je Variante und die
     Suchbegriffe werden hier im Browser abgeleitet, mit denselben Regeln wie der
     Rollen-Sync (rl-bundle-app/app/reel-describe.js). Lieber keine Angabe als eine falsche.
   - Texte auf Deutsch, Bestellposition "Rolle".
   - Variante wird über einen Klick auf das Optionsfeld des Themes gewählt (Nitro nimmt das an).
   - Vorauswahl über ?rolle=<handle> (Rollenseite, Rollenfinder), ?reel= geht auch.
   - Galerie und Warenkorb zeigen das Serienbild der gewählten Rolle (Familien-Sets).
   ============================================================ */
(function () {
  'use strict';

  if (window.RLExactFit) return;

  // Texte je Sprache kommen aus dem Theme (snippets/rl-ef-texte.liquid), Deutsch als Rückfall
  var RT = window.RLEF_T || {};
  function T(k, d) { return RT[k] || d; }

  var MAX_SUGGESTIONS = 5;
  var AUTO_OPEN_DELAY = 350;
  var HELP_TEXT = T('help', 'Mehrere Versionen mit unterschiedlichen Lagern. Prüf die Modellnummer am Rollenfuß oder auf der Verpackung.');
  // Baureihe im Rollenmodell -> Schlüssel der Familien-Sets, wo der Name abweicht
  var SERIES_ALIAS = { 'calcutta-conquest': 'calcutta' };
  // Dateinamen der Klassenbilder (ohne Logo) auf den drei Produkten
  var GENERIC_RE = /rl-tng-(apex|edge|core)-spulenlager-set(-mit-abdeckung|-offen)?(_[0-9a-f-]+)?\.(jpe?g|png|webp)/i;
  var uid = 0;

  /* ---------- Helfer ------------------------------------------ */

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function lower(value) {
    return String(value == null ? '' : value).toLowerCase();
  }

  // klein, nur Buchstaben, Ziffern und Punkte: "CU-DC 201XG" -> "cudc201xg"
  function squash(value) {
    return lower(value).replace(/[^a-z0-9.]+/g, '');
  }

  // Reine Zahlen zählen nur, wenn keine andere Ziffer daran stößt: "201" findet "201 XG", nicht "2018".
  function contains(text, token) {
    if (!/^[0-9]+$/.test(token)) return text.indexOf(token) !== -1;
    var from = 0;
    while (true) {
      var at = text.indexOf(token, from);
      if (at === -1) return false;
      var before = at > 0 ? text.charAt(at - 1) : '';
      var after = text.charAt(at + token.length);
      if (!/[0-9]/.test(before) && !/[0-9]/.test(after)) return true;
      from = at + 1;
    }
  }

  function rootUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function readJSON(scope, selector) {
    var el = scope.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  function handleize(value) {
    return lower(value)
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function capitalize(text) {
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : '';
  }

  function joinOr(list) {
    if (list.length < 2) return list.join('');
    return list.slice(0, -1).join(', ') + T('oder', ' oder ') + list[list.length - 1];
  }

  function handLabel(hand) {
    if (hand === 'left') return T('linkshand', 'Linkshand');
    if (hand === 'right') return T('rechtshand', 'Rechtshand');
    return '';
  }

  // "Größe 200 · Linkshand · XG". Leer, wenn für die Version nichts sicher ableitbar ist.
  function versionFacts(variant) {
    var parts = [];
    if (variant.size) parts.push(T('groesse', 'Größe') + ' ' + variant.size);
    if (variant.hand) parts.push(handLabel(variant.hand));
    if (variant.gear) parts.push(variant.gear);
    return parts.join(' · ');
  }

  function reelImgHTML(url, width, className) {
    if (!url) return '';
    var sized = function (w) {
      return url.replace(/([?&]width=)\d+/, function (match, prefix) {
        return prefix + w;
      });
    };
    return (
      '<img class="' + className + '" src="' + esc(sized(width)) + '" srcset="' + esc(sized(width)) + ' 1x, ' + esc(sized(width * 2)) + ' 2x"' +
      ' width="' + width + '" height="' + width + '" loading="lazy" decoding="async" alt="">'
    );
  }

  /* ---------- Ableitungen (wie rl-bundle-app/app/reel-describe.js) ---------- */

  var GEAR_ORDER = ['PG', 'P', 'MG', 'H', 'HG', 'SH', 'HS', 'XH', 'XS', 'XG', 'XXH', 'XXS'];
  var DAIWA_GEARS = ['P', 'H', 'SH', 'HS', 'XH', 'XS', 'XXH', 'XXS'];

  // Liste aus dem Rollenmodell (["3x10x4 | 3x8x4"]) -> ["3x10x4","3x8x4"], groß vor klein. Genau zwei, sonst null.
  function parseSizes(raw) {
    if (!raw) return null;
    var text = Array.isArray(raw) ? raw.join(' | ') : String(raw).trim();
    if (text.charAt(0) === '[') {
      try {
        var arr = JSON.parse(text);
        if (Array.isArray(arr)) text = arr.join(' | ');
      } catch (error) {
        /* Rohtext weiterverwenden */
      }
    }
    var sizes = text
      .replace(/(\d),(\d)/g, '$1.$2')
      .split(/[|+;]/)
      .map(function (s) {
        return s.trim().toLowerCase();
      })
      .filter(Boolean);
    if (sizes.length !== 2) return null;
    if (!sizes.every(function (s) { return /^\d+(\.\d+)?x\d+(\.\d+)?x\d+(\.\d+)?$/.test(s); })) return null;
    var nums = function (s) {
      return s.split('x').map(Number);
    };
    sizes.sort(function (a, b) {
      var x = nums(a);
      var y = nums(b);
      return y[0] - x[0] || y[1] - x[1] || y[2] - x[2];
    });
    return sizes;
  }

  // Varianten-Liste: je Zeile "Label | Modell-ID | Hersteller-ID"
  function parseVariants(raw) {
    var out = [];
    var seen = {};
    String(raw || '').split(/\r?\n/).forEach(function (line) {
      var parts = line.split('|').map(function (t) {
        return t.trim();
      });
      if (!parts[0] && !parts[1] && !parts[2]) return;
      var key = parts.join('|');
      if (seen[key]) return;
      seen[key] = true;
      out.push({ label: parts[0] || '', model_id: parts[1] || '', maker_id: parts[2] || '' });
    });
    return out;
  }

  function handFromTokens(tokens) {
    var hand = '';
    for (var i = 0; i < tokens.length; i++) {
      var u = tokens[i].toUpperCase();
      var h = '';
      if (u === 'L' || u === 'LH' || u === 'LEFT') h = 'left';
      if (u === 'R' || u === 'RH' || u === 'RIGHT') h = 'right';
      if (!h) continue;
      if (hand && hand !== h) return 'conflict';
      hand = h;
    }
    return hand;
  }

  function ratioFrom(tokens) {
    for (var i = 0; i < tokens.length; i++) if (/^\d{1,2}\.\d$/.test(tokens[i])) return tokens[i] + ':1';
    return '';
  }

  function describeShimano(tokens) {
    var out = {};
    var num = tokens.filter(function (t) { return /^\d{2,4}$/.test(t); })[0];
    var digitHand = '';
    if (num) {
      var last = Number(num.charAt(num.length - 1));
      if (last === 0 || last === 1) {
        out.size = String(Number(num) - last);
        digitHand = last === 1 ? 'left' : 'right';
      }
    }
    var tokenHand = handFromTokens(tokens);
    if (!(tokenHand === 'conflict' || (digitHand && tokenHand && digitHand !== tokenHand))) {
      var hand = digitHand || tokenHand;
      if (hand) out.hand = hand;
    }
    // "XGLH" = XG mit langer Kurbel, kein Linkshand-Kürzel
    for (var i = 0; i < tokens.length; i++) {
      var m = tokens[i].toUpperCase().match(/^(PG|MG|HG|XG)(LH)?$/);
      if (m) {
        out.gear = m[1];
        break;
      }
    }
    if (!out.gear) {
      var ratio = ratioFrom(tokens);
      if (ratio) out.gear = ratio;
    }
    return out;
  }

  function describeDaiwa(label, tokens, modelId) {
    var out = {};
    var tokenHand = handFromTokens(tokens);
    if (tokenHand && tokenHand !== 'conflict') out.hand = tokenHand;
    var ratio = ratioFrom(tokens);
    if (ratio) out.gear = ratio;
    var text = String(label || '')
      .toUpperCase()
      .replace(/-CC\b/g, ' ')
      .replace(/(\d)\s*(?:SV|S)-/g, '$1 ')
      .replace(/(\d)SV\b/g, '$1 ')
      .replace(/\s+/g, ' ')
      .trim();
    var m = text.match(/^(?:(\d{2,4}))?\s*([A-Z]{0,6})$/);
    if (m && !ratio && (m[1] || m[2])) {
      if (m[1]) out.size = m[1];
      var read = function (code) {
        if (code === '') return { gear: '', left: false };
        if (code === 'L') return { gear: '', left: true };
        if (DAIWA_GEARS.indexOf(code) !== -1) return { gear: code, left: false };
        if (code.charAt(code.length - 1) === 'L' && DAIWA_GEARS.indexOf(code.slice(0, -1)) !== -1) return { gear: code.slice(0, -1), left: true };
        return null;
      };
      var raw = m[2] || '';
      var tries = [raw];
      if (m[1] && raw.length > 1) tries.push(raw.replace(/^E/, ''), raw.replace(/A$/, ''), raw.replace(/^E/, '').replace(/A$/, ''));
      var parsed = null;
      for (var i = 0; i < tries.length; i++) {
        if (tries[i] !== raw && tries[i] === '') continue;
        parsed = read(tries[i]);
        if (parsed) break;
      }
      if (parsed) {
        if (parsed.gear) out.gear = parsed.gear;
        if (!out.hand) out.hand = parsed.left ? 'left' : 'right';
      }
    }
    if (!out.hand && modelId && /[A-Z]/i.test(modelId) && /\d/.test(modelId)) {
      var tail = String(modelId).toUpperCase().match(/\d([A-Z]{1,4})$/);
      if (tail) {
        var code = tail[1];
        if (code === 'L' || (code.charAt(code.length - 1) === 'L' && DAIWA_GEARS.indexOf(code.slice(0, -1)) !== -1)) out.hand = 'left';
        else if (DAIWA_GEARS.indexOf(code) !== -1) out.hand = 'right';
      }
    }
    return out;
  }

  function describeOther(tokens) {
    var out = {};
    var hand = handFromTokens(tokens);
    if (hand && hand !== 'conflict') out.hand = hand;
    var ratio = ratioFrom(tokens);
    if (ratio) out.gear = ratio;
    var num = tokens.filter(function (t) { return /^\d{2,4}$/.test(t); })[0];
    if (num) out.size = num;
    return out;
  }

  function describeVariant(brand, label, modelId) {
    var tokens = String(label || '').trim().split(/\s+/).filter(Boolean);
    if (!tokens.length) return {};
    var b = lower(brand);
    if (b === 'shimano') return describeShimano(tokens);
    if (b === 'daiwa') return describeDaiwa(label, tokens, modelId);
    return describeOther(tokens);
  }

  // "17 Curado K" + 2017 -> "Curado K (2017)"
  function displayName(name, year) {
    var clean = String(name || '').trim();
    var y = String(year || '').trim();
    var m = clean.match(/^(\d{2})\s+(.+)$/);
    var bare = m ? m[2].trim() : clean;
    var fullYear = /^\d{4}$/.test(y) ? y : '';
    if (!fullYear && m) {
      var nn = Number(m[1]);
      fullYear = String((nn <= 40 ? 2000 : 1900) + nn);
    }
    return fullYear ? bare + ' (' + fullYear + ')' : bare;
  }

  function gearRank(gear) {
    if (/:1$/.test(gear)) return [0, parseFloat(gear)];
    var i = GEAR_ORDER.indexOf(gear);
    return [1, i === -1 ? 99 : i];
  }

  // "300 / 301 · 200 / 201 · HG, XG"
  function sizesLine(brand, variants) {
    var list = variants.filter(function (v) { return v.size || v.gear; });
    if (!list.length) return '';
    var parts = [];
    if (lower(brand) === 'shimano') {
      var sizes = {};
      list.forEach(function (v) {
        if (!v.size) return;
        var s = sizes[v.size] || { right: false, left: false };
        if (v.hand === 'left') s.left = true;
        else if (v.hand === 'right') s.right = true;
        sizes[v.size] = s;
      });
      Object.keys(sizes)
        .sort(function (a, b) { return Number(b) - Number(a); })
        .forEach(function (size) {
          var s = sizes[size];
          var nums = [];
          if (s.right) nums.push(String(Number(size)));
          if (s.left) nums.push(String(Number(size) + 1));
          if (nums.length) parts.push(nums.join(' / '));
        });
    } else {
      var seen = {};
      list.forEach(function (v) { if (v.size) seen[v.size] = true; });
      Object.keys(seen).sort(function (a, b) { return Number(b) - Number(a); }).forEach(function (n) { parts.push(n); });
    }
    var gears = {};
    list.forEach(function (v) { if (v.gear) gears[v.gear] = true; });
    var gearList = Object.keys(gears).sort(function (a, b) {
      var x = gearRank(a);
      var y = gearRank(b);
      return x[0] - y[0] || x[1] - y[1];
    });
    if (gearList.length) parts.push(gearList.join(', '));
    return parts.join(' · ');
  }

  function handWords(hand) {
    if (hand === 'left') return 'left lh links linkshand';
    if (hand === 'right') return 'right rh rechts rechtshand';
    return '';
  }

  /* ---------- Rollen-Daten ------------------------------------ */

  var Store = {
    promise: null,
    series: {},

    load: function (url) {
      if (this.promise) return this.promise;
      var self = this;
      this.promise = fetchPage(url, 1)
        .then(function (first) {
          self.series = seriesMap(first.seriesList || []);
          var pages = Number(first.pages) || 1;
          var jobs = [];
          for (var page = 2; page <= pages; page++) jobs.push(fetchPage(url, page));
          return Promise.all(jobs).then(function (rest) {
            var reels = first.reels || [];
            rest.forEach(function (chunk) {
              reels = reels.concat(chunk.reels || []);
            });
            return reels.map(prepareReel).filter(Boolean);
          });
        })
        .catch(function (error) {
          self.promise = null;
          throw error;
        });
      return this.promise;
    }
  };

  // [[familie, schlüssel, url], ...] -> { curado: { apex: url, edge_sealed: url, ... } }
  function seriesMap(list) {
    var map = {};
    list.forEach(function (row) {
      if (!row || row.length < 3) return;
      var family = row[0];
      map[family] = map[family] || {};
      if (!map[family][row[1]]) map[family][row[1]] = row[2];
    });
    return map;
  }

  function fetchPage(url, page) {
    var target = url + (url.indexOf('?') === -1 ? '?' : '&') + 'page=' + page;
    return fetch(target, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Exact Fit: Daten nicht geladen (' + response.status + ')');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var data = readJSON(doc, 'script[data-rl-exact-fit-data]');
        if (!data) throw new Error('Exact Fit: Daten nicht lesbar');
        return data;
      });
  }

  function buildTerms(brand, series, name, year, variants) {
    var terms = {};
    var add = function (text) {
      lower(text).split(/[^a-z0-9.]+/).forEach(function (t) { if (t) terms[t] = true; });
    };
    add(brand + ' ' + series + ' ' + name + ' ' + year);
    variants.forEach(function (v) {
      if (v.label) {
        add(v.label);
        var tight = lower(v.label).replace(/[^a-z0-9.]+/g, '');
        if (tight) terms[tight] = true;
        var num = v.label.match(/\d+/);
        if (num) terms[num[0]] = true;
      }
      [v.model_id, v.maker_id].forEach(function (id) {
        if (!id) return;
        var asIs = lower(id).trim();
        if (!/\s/.test(asIs)) terms[asIs] = true;
        else add(asIs);
        var tightId = asIs.replace(/[\s-]+/g, '');
        if (tightId) terms[tightId] = true;
      });
      handWords(v.hand).split(' ').forEach(function (w) { if (w) terms[w] = true; });
    });
    return Object.keys(terms).join(' ');
  }

  function prepareReel(raw) {
    var sizes = parseSizes(raw.g);
    if (!sizes) return null; // Stationärrolle o. ä.: keine zwei Spulenlager
    var brand = String(raw.b || '').trim();
    var series = String(raw.r || '').trim();
    var name = String(raw.n || '').trim();
    var year = String(raw.y || '').trim();
    var variants = parseVariants(raw.v).map(function (v) {
      var d = describeVariant(brand, v.label, v.model_id);
      v.size = d.size || '';
      v.hand = d.hand || '';
      v.gear = d.gear || '';
      return v;
    });
    var display = displayName(name, year);
    var label = brand && lower(display).indexOf(lower(brand)) !== 0 ? brand + ' ' + display : display;
    var generation = name.match(/^(\d{2})\s+(.+)$/);
    var seriesKey = handleize(series);

    var reel = {
      h: raw.h,
      u: raw.u || '',
      n: name,
      b: brand,
      r: series,
      y: year,
      s: sizes.join(' + '),
      k: sizes.join('_'),
      p: !!raw.p,
      rt: lower(raw.rt || '').trim(),
      img: raw.img || '',
      d: display,
      z: sizesLine(brand, variants),
      label: label,
      year: parseInt(year, 10) || 0,
      gen: generation ? generation[1] : '',
      bare: generation ? generation[2] : name,
      series: SERIES_ALIAS[seriesKey] || seriesKey
    };

    reel.variants = variants.map(function (v) {
      return {
        label: v.label,
        model: v.model_id,
        maker: v.maker_id,
        size: v.size,
        hand: v.hand,
        gear: v.gear,
        words: lower(v.label).split(/\s+/).filter(Boolean),
        ids: [squash(v.model_id), squash(v.maker_id)].filter(Boolean),
        hay: [lower(v.label), squash(v.label), lower(v.model_id), squash(v.model_id), lower(v.maker_id), squash(v.maker_id), handWords(v.hand)].join(' ')
      };
    });

    var base = lower([brand, series, name, year].join(' ')).replace(/\s+/g, ' ').trim();
    var shortYear = reel.year > 1900 ? String(reel.year).slice(2) : '';
    reel.base = (base + ' ' + shortYear).trim();
    reel.baseTight = base.replace(/ /g, '');
    var variantHay = reel.variants.map(function (v) { return v.hay; }).join(' ');
    var hay = lower([buildTerms(brand, series, name, year, variants), label, name, shortYear, variantHay].join(' ')).replace(/\s+/g, ' ').trim();
    reel.hay = hay;
    reel.words = hay.split(' ');
    reel.tight = hay.replace(/ /g, '');
    return reel;
  }

  /* ---------- Suche (wie Kazemaki) ----------------------------- */

  // true bei Abstand 0 oder 1 (ein Zeichen anders, eingefügt, gelöscht oder zwei Nachbarn vertauscht)
  function near(a, b) {
    if (a === b) return true;
    var la = a.length;
    var lb = b.length;
    if (Math.abs(la - lb) > 1) return false;
    var i = 0;
    while (i < la && i < lb && a.charAt(i) === b.charAt(i)) i++;
    if (la === lb) {
      if (a.slice(i + 1) === b.slice(i + 1)) return true;
      return a.charAt(i) === b.charAt(i + 1) && a.charAt(i + 1) === b.charAt(i) && a.slice(i + 2) === b.slice(i + 2);
    }
    return la > lb ? a.slice(i + 1) === b.slice(i) : a.slice(i) === b.slice(i + 1);
  }

  function tokenHits(reel, token, fuzzy) {
    if (/^[0-9]+$/.test(token)) return contains(reel.hay, token);
    if (reel.hay.indexOf(token) !== -1 || reel.tight.indexOf(token) !== -1) return true;
    if (!fuzzy || token.length < 4) return false;
    return reel.words.some(function (word) {
      if (near(token, word)) return true;
      return word.length > token.length && near(token, word.slice(0, token.length));
    });
  }

  function idHit(reel, whole) {
    if (whole.length < 5) return null;
    for (var i = 0; i < reel.variants.length; i++) {
      var ids = reel.variants[i].ids;
      for (var j = 0; j < ids.length; j++) {
        if (ids[j].indexOf(whole) !== -1) return reel.variants[i];
      }
    }
    return null;
  }

  // "201 xg" muss in EINER Variante stehen
  function variantsAgree(reel, tokens) {
    var own = tokens.filter(function (token) {
      if (contains(reel.base, token) || contains(reel.baseTight, token)) return false;
      return reel.variants.some(function (variant) {
        return contains(variant.hay, token);
      });
    });
    if (own.length < 2) return true;
    return reel.variants.some(function (variant) {
      return own.every(function (token) {
        return contains(variant.hay, token);
      });
    });
  }

  function bestVariant(reel, tokens, whole) {
    if (!reel.variants.length) return null;
    var byId = idHit(reel, whole);
    if (byId) return byId;
    var own = tokens.filter(function (token) {
      return !contains(reel.base, token) && !contains(reel.baseTight, token);
    });
    if (!own.length) return null;
    var candidates = reel.variants.filter(function (variant) {
      return own.every(function (token) {
        return contains(variant.hay, token);
      });
    });
    if (!candidates.length) return null;
    var rank = function (variant) {
      var exactWords = own.every(function (token) {
        return variant.words.indexOf(token) !== -1;
      });
      return (exactWords ? 0 : 100) + variant.words.length;
    };
    var sorted = candidates.slice().sort(function (a, b) {
      return rank(a) - rank(b);
    });
    var top = sorted.filter(function (variant) {
      return rank(variant) === rank(sorted[0]);
    });
    return top.length === 1 ? top[0] : sharedVariant(top);
  }

  // "curado dc 200" passt auf 200 HG und 200 XG: nie die Übersetzung raten, nur das Gemeinsame
  function sharedVariant(list) {
    var same = function (key) {
      return list.every(function (variant) {
        return variant[key] === list[0][key];
      })
        ? list[0][key]
        : '';
    };
    var label = list[0].words
      .filter(function (word) {
        return list.every(function (variant) {
          return variant.words.indexOf(word) !== -1;
        });
      })
      .join(' ')
      .toUpperCase();
    return { label: label, model: '', maker: '', size: same('size'), hand: same('hand'), gear: same('gear'), words: lower(label).split(/\s+/).filter(Boolean), ids: [], hay: '' };
  }

  function commonWords(names) {
    if (!names.length) return '';
    var lists = names.slice(1).map(function (name) {
      return lower(name).split(/\s+/);
    });
    return names[0]
      .split(/\s+/)
      .filter(function (word) {
        return lists.every(function (list) {
          return list.indexOf(lower(word)) !== -1;
        });
      })
      .join(' ');
  }

  function reelEntry(reel, variant) {
    // Eigenschaft an der Bestellposition: "Shimano Curado DC (2022) 201 XG (Linkshand)"
    var prop = reel.label;
    if (variant && variant.label) prop += ' ' + variant.label;
    if (variant && variant.hand) prop += ' (' + handLabel(variant.hand) + ')';
    return {
      type: 'reel',
      reel: reel,
      variant: variant || null,
      handle: reel.h,
      url: reel.u || '',
      title: reel.label,
      prop: prop,
      s: reel.s,
      k: reel.k,
      p: reel.p,
      pSome: false,
      rt: reel.rt,
      series: reel.series,
      img: reel.img || '',
      code: variant ? variant.model : ''
    };
  }

  // Ein Eintrag "Alle …", nur wenn alle Treffer dieselben Lager brauchen
  function groupEntry(found, tokens, whole, reels) {
    var name = commonWords(found.map(function (reel) { return reel.bare; }));
    if (!name) return null;
    var brands = {};
    var gens = {};
    var picks = {};
    var seriesSet = {};
    var sameName = true;
    var variantLabel = null;
    var groupVariant = null;
    var pins = 0;
    found.forEach(function (reel) {
      brands[reel.b || ''] = true;
      picks[reel.rt || ''] = true;
      seriesSet[reel.series] = true;
      if (reel.year) gens[reel.year] = true;
      if (lower(reel.bare) !== lower(name)) sameName = false;
      if (reel.p) pins++;
      var variant = bestVariant(reel, tokens, whole);
      var label = variant ? variant.label : '';
      if (variantLabel === null) {
        variantLabel = label;
        groupVariant = variant;
      } else if (variantLabel !== label) {
        variantLabel = '';
        groupVariant = null;
      }
    });
    // Gegenprobe über alle Rollen mit diesem Namen: alle müssen dieselben Lager haben
    var nameWords = lower(name).split(/\s+/);
    var honest = (reels || found).every(function (reel) {
      var words = lower(reel.bare).split(/\s+/);
      var sameReel = nameWords.every(function (word) { return words.indexOf(word) !== -1; });
      if (!sameReel) return true;
      if (variantLabel) {
        var hasVariant = reel.variants.some(function (variant) { return variant.label === variantLabel; });
        if (!hasVariant) return true;
      }
      return reel.k === found[0].k;
    });
    if (!honest) return null;
    var brandList = Object.keys(brands);
    var title = (brandList.length === 1 && brandList[0] ? brandList[0] + ' ' : '') + name;
    var genList = Object.keys(gens).sort();
    var notes = [];
    if (groupVariant && groupVariant.hand) notes.push(handLabel(groupVariant.hand));
    notes.push(sameName && genList.length > 1 ? joinOr(genList) : T('alle_versionen', 'alle Versionen'));
    var note = (groupVariant && groupVariant.label ? ' ' + groupVariant.label : '') + ' (' + notes.join(', ') + ')';
    return {
      type: 'group',
      reel: null,
      variant: groupVariant && groupVariant.label ? groupVariant : null,
      handle: '',
      url: '',
      short: name,
      title: title,
      prop: title + note,
      s: found[0].s,
      k: found[0].k,
      p: pins === found.length,
      pSome: pins > 0 && pins < found.length,
      rt: Object.keys(picks).length === 1 ? Object.keys(picks)[0] : '',
      series: Object.keys(seriesSet).length === 1 ? Object.keys(seriesSet)[0] : '',
      img: found[0].img || '',
      code: ''
    };
  }

  function analyse(reels, query, limit) {
    var result = { entries: [], help: false, exact: null, count: 0 };
    var tokens = lower(query)
      .trim()
      .split(/\s+/)
      .map(function (token) { return token.replace(/[^a-z0-9.]+/g, ''); })
      .filter(Boolean);
    if (!tokens.length) return result;
    var whole = squash(query);
    var run = function (fuzzy) {
      return reels.filter(function (reel) {
        var byTokens = tokens.every(function (token) { return tokenHits(reel, token, fuzzy); });
        return (byTokens && variantsAgree(reel, tokens)) || !!idHit(reel, whole);
      });
    };
    var found = run(false);
    if (!found.length) found = run(true);
    if (!found.length) return result;
    var score = function (reel) {
      return tokens.reduce(function (sum, token) {
        if (reel.words.indexOf(token) !== -1) return sum + 3;
        var atStart = reel.words.some(function (word) { return word.indexOf(token) === 0; });
        return sum + (atStart ? 1 : 0);
      }, 0);
    };
    found = found
      .map(function (reel) { return { reel: reel, score: score(reel) }; })
      .sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        if (b.reel.year !== a.reel.year) return b.reel.year - a.reel.year;
        return a.reel.label.localeCompare(b.reel.label);
      })
      .map(function (entry) { return entry.reel; });
    result.count = found.length;
    if (whole.length >= 4) {
      var exact = [];
      found.forEach(function (reel) {
        reel.variants.forEach(function (variant) {
          if (variant.ids.indexOf(whole) !== -1) exact.push(reelEntry(reel, variant));
        });
      });
      if (exact.length === 1) result.exact = exact[0];
    }
    var sizeKeys = {};
    found.forEach(function (reel) { sizeKeys[reel.k] = true; });
    var oneSize = Object.keys(sizeKeys).length === 1;
    var related = found.length > 1 && !!commonWords(found.map(function (reel) { return reel.bare; }));
    var group = related && oneSize ? groupEntry(found, tokens, whole, reels) : null;
    result.help = related && !oneSize;
    var max = (limit || MAX_SUGGESTIONS) - (group ? 1 : 0);
    result.entries = found.slice(0, max).map(function (reel) {
      var variant = bestVariant(reel, tokens, whole);
      var entry = reelEntry(reel, variant);
      if (result.help && !entry.code && reel.variants.length) entry.code = reel.variants[0].model;
      return entry;
    });
    if (group) result.entries.unshift(group);
    return result;
  }

  /* ---------- Combobox ----------------------------------------- */

  function Combo(host, options) {
    this.host = host;
    this.options = options;
    this.input = host.querySelector('[data-rlef-input]');
    this.list = host.querySelector('[data-rlef-list]');
    this.clear = host.querySelector('[data-rlef-clear]');
    this.reels = null;
    this.results = [];
    this.active = -1;
    this.autoTimer = null;
    this.prefix = 'rlef-opt-' + ++uid;
    if (!this.input || !this.list) return;
    if (!this.list.id) this.list.id = this.prefix + '-list';
    this.input.setAttribute('aria-controls', this.list.id);
    this.input.addEventListener('focus', this.ensureData.bind(this));
    this.input.addEventListener('input', this.onInput.bind(this));
    this.input.addEventListener('keydown', this.onKeydown.bind(this));
    this.list.addEventListener('mousedown', function (event) {
      event.preventDefault(); // Fokus bleibt im Feld
    });
    this.list.addEventListener('click', this.onListClick.bind(this));
    if (this.clear) this.clear.addEventListener('click', this.reset.bind(this));
    document.addEventListener('click', this.onOutside.bind(this));
  }

  Combo.prototype.ensureData = function () {
    var self = this;
    if (this.reels) return Promise.resolve(this.reels);
    return Store.load(this.options.dataUrl)
      .then(function (reels) {
        self.reels = reels;
        if (document.activeElement === self.input && self.input.value.trim()) self.update();
        return reels;
      })
      .catch(function () {
        self.showMessage(T('liste_fehler', 'Die Rollenliste konnte nicht geladen werden. Bitte lade die Seite neu.'));
        return null;
      });
  };

  Combo.prototype.onInput = function () {
    if (this.clear) this.clear.hidden = !this.input.value;
    if (this.options.onType) this.options.onType();
    if (!this.reels) {
      this.ensureData();
      return;
    }
    this.update();
  };

  Combo.prototype.update = function () {
    var self = this;
    var query = this.input.value.trim();
    clearTimeout(this.autoTimer);
    if (query.length < 2) {
      this.close();
      return;
    }
    var found = analyse(this.reels, query, this.options.limit || MAX_SUGGESTIONS);
    this.results = found.entries;
    this.active = -1;
    if (!this.results.length) {
      this.showMessage(this.options.emptyText);
      return;
    }
    var prefix = this.prefix;
    var dotFor = this.options.dotFor || function () { return ''; };
    var html = found.help ? '<li class="rlef-list__help" role="presentation">' + esc(HELP_TEXT) + '</li>' : '';
    html += this.results
      .map(function (entry, index) {
        var open = '<li class="rlef-list__item' + (entry.type === 'group' ? ' rlef-list__item--group' : '') + '" role="option" id="' + prefix + '-' + index + '" data-index="' + index + '" aria-selected="false">';
        var thumb = '<span class="rlef-list__thumb">' + reelImgHTML(entry.img, 40, 'rlef-list__img') + '</span>';
        var dot = dotFor(entry);
        if (entry.type === 'group') {
          var gf = entry.variant ? versionFacts(entry.variant) : '';
          return (
            open + thumb +
            '<span class="rlef-list__name">' + esc(T('alle', 'Alle')) + ' ' + esc(entry.short) + '</span>' +
            '<span class="rlef-list__sub">' + esc(gf ? gf + ' · ' + T('gleiche_lager_kurz', 'alle Versionen mit denselben Lagern') : T('gleiche_lager', 'Alle Versionen nutzen dieselben Lager')) + '</span>' +
            '<span class="rlef-list__sizes">' + esc(entry.s) + '</span>' + dot +
            '</li>'
          );
        }
        var sub = '';
        if (entry.variant && entry.variant.label) {
          var facts = versionFacts(entry.variant);
          sub = facts || entry.variant.label;
        } else if (entry.reel.z) {
          sub = entry.reel.z;
        }
        return (
          open + thumb +
          '<span class="rlef-list__name">' + esc(entry.reel.label) + '</span>' +
          (sub ? '<span class="rlef-list__sub">' + esc(sub) + '</span>' : '') +
          '<span class="rlef-list__sizes">' + esc(entry.s) + '</span>' + dot +
          '</li>'
        );
      })
      .join('');
    this.list.innerHTML = html;
    this.open();
    // komplette Modell- oder Hersteller-ID: ohne Klick übernehmen
    if (found.exact) {
      this.autoTimer = setTimeout(function () {
        if (self.input.value.trim() !== query) return;
        self.setValue(found.exact.title);
        self.close();
        self.options.onSelect(found.exact, { auto: true });
      }, AUTO_OPEN_DELAY);
    }
  };

  Combo.prototype.showMessage = function (text) {
    this.results = [];
    this.active = -1;
    this.list.innerHTML = '<li class="rlef-list__empty" role="presentation">' + esc(text) + '</li>';
    this.open();
  };

  Combo.prototype.open = function () {
    this.list.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
    this.input.removeAttribute('aria-activedescendant');
  };

  Combo.prototype.close = function () {
    clearTimeout(this.autoTimer);
    this.list.hidden = true;
    this.list.innerHTML = '';
    this.results = [];
    this.active = -1;
    this.input.setAttribute('aria-expanded', 'false');
    this.input.removeAttribute('aria-activedescendant');
  };

  Combo.prototype.reset = function () {
    this.input.value = '';
    if (this.clear) this.clear.hidden = true;
    this.close();
    this.input.focus();
    if (this.options.onReset) this.options.onReset();
  };

  Combo.prototype.setValue = function (text) {
    this.input.value = text;
    if (this.clear) this.clear.hidden = !text;
  };

  Combo.prototype.setActive = function (index) {
    var items = this.list.querySelectorAll('[role="option"]');
    if (!items.length) return;
    this.active = (index + items.length) % items.length;
    var self = this;
    items.forEach(function (item, position) {
      var selected = position === self.active;
      item.setAttribute('aria-selected', selected ? 'true' : 'false');
      if (selected) {
        self.input.setAttribute('aria-activedescendant', item.id);
        item.scrollIntoView({ block: 'nearest' });
      }
    });
  };

  Combo.prototype.onKeydown = function (event) {
    var isOpen = !this.list.hidden && this.results.length > 0;
    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        if (isOpen) this.setActive(this.active + 1);
        else if (this.reels) this.update();
        break;
      case 'ArrowUp':
        event.preventDefault();
        if (isOpen) this.setActive(this.active < 0 ? -1 : this.active - 1);
        break;
      case 'Enter':
        event.preventDefault(); // das Feld sitzt im Kaufformular, nie absenden
        if (isOpen) this.choose(this.active >= 0 ? this.active : 0);
        break;
      case 'Escape':
        if (!this.list.hidden) {
          event.preventDefault();
          this.close();
        }
        break;
      case 'Tab':
        this.close();
        break;
    }
  };

  Combo.prototype.onListClick = function (event) {
    var item = event.target.closest('[role="option"]');
    if (item) this.choose(Number(item.getAttribute('data-index')));
  };

  Combo.prototype.onOutside = function (event) {
    if (!this.host.contains(event.target)) this.close();
  };

  Combo.prototype.choose = function (index) {
    var entry = this.results[index];
    if (!entry) return;
    this.setValue(entry.title);
    this.close();
    this.options.onSelect(entry, { auto: false });
  };

  /* ---------- Warenkorb (Lagerfinder) --------------------------- */

  // Legt das Set mit Rolle und Serienbild in den Warenkorb. Über die Warenkorb-Schnittstelle des
  // Themes, damit Zähler und Drawer wie beim normalen Kauf reagieren.
  function addToCart(variantId, reelName, imageFile) {
    var core = window.themeCore;
    var id = Number(variantId);
    if (core && core.CartApi && core.CartApi.actions) {
      var item = { id: id, quantity: 1 };
      if (reelName) item['properties[Rolle]'] = reelName;
      if (imageFile) item['properties[_Exact Fit Bild]'] = imageFile;
      return core.CartApi.makeRequest(core.CartApi.actions.ADD_TO_CART, item);
    }
    var line = { id: id, quantity: 1, properties: {} };
    if (reelName) line.properties.Rolle = reelName;
    if (imageFile) line.properties['_Exact Fit Bild'] = imageFile;
    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [line] })
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (data) { throw data; });
      window.location.href = rootUrl() + 'cart';
      return null;
    });
  }

  /* ---------- Ergebniskarte (Lagerfinder) ---------------------- */

  // Kurztext je Klasse für "Warum?". Beschreibt nur die Klasse, keine Behauptung über die Rolle.
  var PICK_REASONS = {
    apex: T('pick_apex', 'APEX holt das Maximum aus deiner Rolle: frühester Spulenstart, längster Freilauf.'),
    edge: T('pick_edge', 'EDGE ist der Allrounder: Keramik-Speed mit der Robustheit von Stahl, gemacht für Belastung.'),
    core: T('pick_core', 'CORE ist für harte Arbeit gebaut: komplett Edelstahl, für schwere Köder und viel Last.')
  };

  function rangeText(range) {
    var parts = String(range || '').split('-');
    return parts.length === 2 && parts[0] && parts[1] ? parts[0] + T('bis', ' bis ') + parts[1] + ' g' : '';
  }

  // Serienbild der Klasse für die Baureihe, sonst das Klassenbild ohne Logo.
  function tileImage(cls, entry, key, fallback) {
    var own = entry.series ? (Store.series || {})[entry.series] : null;
    if (own && own[key]) return { url: own[key], series: true };
    return fallback ? { url: fallback, series: false } : null;
  }

  function tileImgHTML(image, alt, seal, off) {
    if (!image) return '';
    var sized = function (width) {
      return /[?&]width=\d+/.test(image.url)
        ? image.url.replace(/([?&]width=)\d+/, function (match, prefix) { return prefix + width; })
        : image.url + (image.url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    };
    return (
      '<img class="rlef-tile__img' + (off ? ' is-off' : '') + '"' +
      (seal ? ' data-rlef-img="' + esc(seal) + '"' : '') +
      ' src="' + esc(sized(480)) + '" srcset="' + esc(sized(480)) + ' 1x, ' + esc(sized(960)) + ' 2x"' +
      ' width="480" height="480" loading="lazy" decoding="async" alt="' + esc(alt) + '">'
    );
  }

  function tileHTML(cls, variants, isPick, entry) {
    var tierKey = lower(cls.tier);
    var hasSeal = variants.some(function (v) { return !!v.seal; });
    var current = variants.filter(function (v) { return v.available; })[0] || variants[0];
    if (hasSeal) current = variants.filter(function (v) { return /^mit/i.test(v.seal) && v.available; })[0] || current;
    var alt = cls.tier + ' ' + T('set_name', 'Spulenlager Set') + (entry.title ? T('fuer', ' für ') + entry.title : '');

    var seal = '';
    var media = '';
    if (hasSeal) {
      seal =
        '<div class="rlef-seal" role="radiogroup" aria-label="' + esc(T('abdeckung', 'Abdeckung')) + '">' +
        variants.map(function (v) {
          var label = /^offen/i.test(v.seal) ? 'Offen' : 'Mit Abdeckung';
          return (
            '<button type="button" class="rlef-seal__btn" role="radio" data-rlef-seal' +
            ' aria-checked="' + (v === current ? 'true' : 'false') + '"' + (v === current ? '' : ' tabindex="-1"') +
            ' data-variant-id="' + esc(v.id) + '" data-price="' + esc(v.price) + '" data-available="' + (v.available ? 'true' : 'false') + '"' +
            ' data-seal="' + (/^offen/i.test(v.seal) ? 'open' : 'sealed') + '">' + esc(label) + '</button>'
          );
        }).join('') +
        '</div>';
      var sealedV = variants.filter(function (v) { return !/^offen/i.test(v.seal); })[0];
      var openV = variants.filter(function (v) { return /^offen/i.test(v.seal); })[0];
      var openFirst = /^offen/i.test(current.seal);
      media =
        tileImgHTML(tileImage(cls, entry, 'edge_sealed', sealedV && sealedV.img), alt + ', ' + T('mit_abdeckung', 'mit Abdeckung'), 'sealed', openFirst) +
        tileImgHTML(tileImage(cls, entry, 'edge_open', openV && openV.img), alt + ', ' + T('offen', 'offen'), 'open', !openFirst);
    } else {
      media = tileImgHTML(tileImage(cls, entry, tierKey, cls.img), alt, '', false);
    }

    // Angaben wie auf den Produktkarten des Shops (Material, Wurf, Einsatz)
    var spec = '';
    var row = function (label, values) {
      var tags = values.filter(Boolean).map(function (v) { return '<span class="bearing-spec-tag">' + esc(v) + '</span>'; }).join('');
      return tags ? '<div class="bearing-spec-row"><span class="bearing-spec-label">' + esc(label) + '</span><span class="bearing-spec-values">' + tags + '</span></div>' : '';
    };
    spec = row(T('material', 'Material:'), [cls.material]) + row(T('wurf', 'Wurf (g):'), [cls.wurf]) + row(T('einsatz', 'Einsatz:'), String(cls.einsatz || '').split(',').map(function (t) { return t.trim(); }).slice(0, 2));
    var series = entry.reel ? entry.reel.r : (entry.short || '');
    var rolle = entry.handle ? '&rolle=' + encodeURIComponent(entry.handle) : '';
    return (
      '<article class="rlef-tile" data-rlef-tile data-class="' + esc(tierKey) + '"' + (isPick ? ' data-pick="true"' : '') +
      ' data-url="' + esc(cls.url) + '" data-rolle="' + esc(entry.handle || '') + '">' +
      (media ? '<div class="rlef-tile__media">' + media + '</div>' : '') +
      '<div class="rlef-tile__body">' +
      (isPick ? '<span class="rlef-tile__pick"><svg width="11" height="11" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 6.5L5 9.5L10 3.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Empfohlen für deine ' + esc(series || 'Rolle') + '</span>' : '') +
      '<h3 class="rlef-tile__name">RL-TNG ' + esc(cls.tier.toUpperCase()) + '</h3>' +
      (cls.claim ? '<p class="rlef-tile__claim">' + esc(cls.claim) + '</p>' : '') +
      (spec ? '<div class="bearing-spec-box">' + spec + '</div>' : '') +
      '</div>' +
      seal +
      '<div class="rlef-tile__buy">' +
      '<p class="rlef-tile__price"><span data-rlef-price>' + esc(current.price) + '</span><small>' + esc(T('zweier_set', '2er Set')) + '</small></p>' +
      '<button type="button" class="rlef-btn" data-rlef-add data-variant-id="' + esc(current.id) + '"' + (current.available ? '' : ' disabled') + '>' +
      (current.available ? T('warenkorb', 'In den Warenkorb') : T('ausverkauft', 'Ausverkauft')) + '</button>' +
      '</div>' +
      '<a class="rlef-tile__details" data-rlef-details href="' + esc(cls.url) + '?variant=' + esc(current.id) + esc(rolle) + '">' + esc(T('mehr_zu', 'Mehr zu')) + ' ' + esc(cls.tier.toUpperCase()) + '</a>' +
      '</article>'
    );
  }

  function cardHTML(entry, config) {
    var classes = config.classes || [];
    var pick = entry.rt
      ? classes.filter(function (c) {
          return lower(c.tier) === entry.rt && c.variants.some(function (v) { return v.sk === entry.k; });
        })[0] || null
      : null;
    // Reihenfolge bleibt APEX, EDGE, CORE. Die Empfehlung wird markiert, nie verschoben.
    var tiles = classes
      .map(function (cls) {
        var variants = cls.variants.filter(function (v) { return v.sk === entry.k; });
        return variants.length ? tileHTML(cls, variants, cls === pick, entry) : '';
      })
      .join('');

    var reelImg = entry.img ? reelImgHTML(entry.img, 160, 'rlef-card__reel') : '';
    var head =
      '<div class="rlef-card__head' + (reelImg ? ' rlef-card__head--img' : '') + '">' +
      (reelImg ? '<div class="rlef-card__reelbox">' + reelImg + '</div>' : '') +
      '<div class="rlef-card__headtext">' +
      '<p class="rlef-card__label">' + esc(T('passt_exakt', 'Passt exakt zu deiner')) + '</p>' +
      '<h2 class="rlef-card__title">' + esc(entry.title) + '</h2>' +
      '<p class="rlef-card__bearings">' + esc(T('spulenlager', 'Spulenlager')) + ' <span class="rlef-mono">' + esc(entry.s) + '</span></p>';
    if (entry.variant && entry.variant.label) {
      var facts = versionFacts(entry.variant);
      head += '<p class="rlef-card__version">' + esc(T('deine_version', 'Deine Version:')) + ' <strong>' + esc(entry.variant.label) + '</strong>' + (facts ? ' · ' + esc(facts) : '') + '</p>';
    }
    if (pick) {
      head +=
        '<p class="rlef-card__pick">' + esc(T('empfehlung', 'Unsere Empfehlung:')) + ' <strong>' + esc(pick.tier.toUpperCase()) + '</strong>. ' +
        esc(PICK_REASONS[entry.rt] || '') + '</p>';
    }
    head += '</div></div>';

    var body = tiles
      ? '<div class="rlef-tiles">' + tiles + '</div>'
      : '<p class="rlef-card__empty">' + esc(T('kein_set', 'Für diese Rolle haben wir noch kein passendes Set (%s). Schreib uns, wir helfen dir weiter.').replace('%s', entry.s)) + '</p>';

    var pin = '';
    if (tiles && (entry.p || entry.pSome) && config.pin && config.pin.id) {
      var p = config.pin;
      pin =
        '<div class="rlef-pin">' +
        (p.img ? '<a class="rlef-pin__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(p.img) + '" width="72" height="72" loading="lazy" decoding="async" alt=""></a>' : '') +
        '<div class="rlef-pin__body">' +
        '<p class="rlef-pin__eyebrow">' + (entry.p ? T('pin_rolle', 'Brauchst du für diese Rolle') : T('pin_versionen', 'Brauchst du für einige Versionen')) + '</p>' +
        '<p class="rlef-pin__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></p>' +
        '<p class="rlef-pin__text">' + esc(T('pin_text', 'Das Spulenlager sitzt hinter einem Stift. Damit drückst du ihn ohne Schaden heraus.')) + '</p>' +
        '</div>' +
        '<div class="rlef-pin__buy"><p class="rlef-pin__price">' + esc(p.price) + '</p>' +
        '<button type="button" class="rlef-btn rlef-btn--ghost" data-rlef-add data-plain="true" data-variant-id="' + esc(p.id) + '"' + (p.available ? '' : ' disabled') + '>' + (p.available ? T('dazu', 'Dazu') : T('ausverkauft', 'Ausverkauft')) + '</button></div>' +
        '</div>';
    }

    var more = entry.url
      ? '<p class="rlef-card__more"><a href="' + esc(entry.url) + '">' + esc(T('alle_teile', 'Alle Tuning-Teile für deine')) + ' ' + esc(entry.reel ? entry.reel.d : entry.title) + '</a></p>'
      : '';

    return (
      '<rl-exact-fit-card class="rlef-card" data-rolle="' + esc(entry.prop || entry.title) + '" data-series="' + esc(entry.series || '') + '" data-available="' + (tiles ? 'true' : 'false') + '">' +
      head + body + pin +
      '<p class="rlef-card__status" role="status" aria-live="polite"></p>' +
      more +
      '</rl-exact-fit-card>'
    );
  }

  class RLExactFitCard extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      var seal = event.target.closest('[data-rlef-seal]');
      if (seal && this.contains(seal)) {
        this.pickSeal(seal);
        return;
      }
      var add = event.target.closest('[data-rlef-add]');
      if (add && this.contains(add) && !add.disabled) this.add(add);
    }

    pickSeal(button) {
      var tile = button.closest('[data-rlef-tile]');
      if (!tile) return;
      tile.querySelectorAll('[data-rlef-seal]').forEach(function (other) {
        var active = other === button;
        other.setAttribute('aria-checked', active ? 'true' : 'false');
        other.tabIndex = active ? 0 : -1;
      });
      var id = button.getAttribute('data-variant-id');
      var available = button.getAttribute('data-available') !== 'false';
      var add = tile.querySelector('[data-rlef-add]');
      if (add) {
        add.setAttribute('data-variant-id', id);
        add.disabled = !available;
        add.textContent = available ? T('warenkorb', 'In den Warenkorb') : T('ausverkauft', 'Ausverkauft');
      }
      var price = tile.querySelector('[data-rlef-price]');
      if (price) price.textContent = button.getAttribute('data-price');
      var details = tile.querySelector('[data-rlef-details]');
      var rolle = tile.getAttribute('data-rolle');
      if (details) details.setAttribute('href', tile.getAttribute('data-url') + '?variant=' + id + (rolle ? '&rolle=' + encodeURIComponent(rolle) : ''));
      var wanted = button.getAttribute('data-seal');
      tile.querySelectorAll('[data-rlef-img]').forEach(function (img) {
        img.classList.toggle('is-off', img.getAttribute('data-rlef-img') !== wanted);
      });
    }

    add(button) {
      var self = this;
      var label = button.textContent;
      var status = this.querySelector('.rlef-card__status');
      button.disabled = true;
      button.textContent = T('wird_gelegt', 'Wird gelegt …');
      if (status) {
        status.textContent = '';
        status.classList.remove('is-error');
      }
      var plain = button.getAttribute('data-plain') === 'true';
      // das Bild, das der Kunde gerade sieht (Edge: gewählte Abdeckung), nur Serienbilder
      var file = '';
      if (!plain) {
        var tile = button.closest('[data-rlef-tile]');
        var img = tile ? tile.querySelector('.rlef-tile__img:not(.is-off)') : null;
        var src = img ? String(img.getAttribute('src') || '') : '';
        if (src && !GENERIC_RE.test(src)) file = src.split('?')[0].split('/').pop();
      }
      addToCart(button.getAttribute('data-variant-id'), plain ? '' : this.getAttribute('data-rolle'), file)
        .then(function () {
          button.textContent = 'Im Warenkorb';
          button.classList.add('is-added');
          setTimeout(function () {
            button.classList.remove('is-added');
            button.textContent = label;
          }, 2200);
        })
        .catch(function (error) {
          button.textContent = label;
          if (status) {
            status.classList.add('is-error');
            status.textContent = (error && (error.description || error.message)) || T('fehler', 'Das hat nicht geklappt. Bitte versuch es noch einmal.');
          }
        })
        .then(function () {
          button.disabled = false;
          if (self.isConnected && document.activeElement === document.body) button.focus();
        });
    }
  }

  /* ---------- <rl-lagerfinder> ---------------------------------- */

  class RLLagerfinder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = readJSON(this, 'script[data-rlef-config]') || { classes: [] };
      this.result = this.querySelector('[data-rlef-finder-result]');
      this.combo = new Combo(this, {
        dataUrl: this.getAttribute('data-data-url'),
        limit: 8,
        emptyText: T('keine_rolle', 'Keine Rolle gefunden. Prüf die Schreibweise, zum Beispiel "Curado DC" oder die Nummer am Rollenfuß.'),
        dotFor: this.dotFor.bind(this),
        onSelect: this.show.bind(this),
        onReset: this.hideResult.bind(this),
        onType: this.hideResult.bind(this)
      });
      this.restoreFromUrl();
    }

    dotFor(entry) {
      if (!entry.rt) return '';
      var cls = (this.config.classes || []).filter(function (c) { return lower(c.tier) === entry.rt; })[0];
      if (!cls || !cls.variants.some(function (v) { return v.sk === entry.k; })) return '';
      var text = T('empfehlung', 'Unsere Empfehlung:') + ' ' + cls.tier;
      return '<span class="rlef-dot" data-class="' + esc(entry.rt) + '" role="img" title="' + esc(text) + '" aria-label="' + esc(text) + '"></span>';
    }

    restoreFromUrl() {
      var self = this;
      var params = new URLSearchParams(window.location.search);
      var handle = params.get('rolle') || params.get('reel');
      if (!handle || !this.combo.input) return;
      this.combo.ensureData().then(function (reels) {
        if (!reels) return;
        var reel = reels.filter(function (r) { return r.h === handle; })[0];
        if (!reel) {
          self.setUrl('');
          return;
        }
        var entry = reelEntry(reel, null);
        self.combo.setValue(entry.title);
        self.show(entry, { restore: true });
      });
    }

    setUrl(handle) {
      if (!window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      if (handle) url.searchParams.set('rolle', handle);
      else url.searchParams.delete('rolle');
      url.searchParams.delete('reel');
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    }

    show(entry, how) {
      if (!this.result) return;
      this.result.hidden = false;
      this.result.innerHTML = cardHTML(entry, this.config);
      this.shown = true;
      var steps = this.querySelector('[data-rlef-steps]');
      if (steps) steps.hidden = true;
      this.setUrl(entry.handle);
      var card = this.result.querySelector('rl-exact-fit-card');
      if (card && !(how && how.restore)) {
        if (this.combo.input && window.matchMedia && window.matchMedia('(max-width: 749px)').matches) this.combo.input.blur();
        setTimeout(function () {
          card.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }, 80);
      }
    }

    hideResult() {
      if (!this.shown) return;
      this.shown = false;
      if (this.result) {
        this.result.innerHTML = '';
        this.result.hidden = true;
      }
      var steps = this.querySelector('[data-rlef-steps]');
      if (steps) steps.hidden = false;
      this.setUrl('');
    }
  }

  /* ---------- <rl-exact-fit-check> ------------------------------ */

  var PENDING_KEY = 'rlexactfit:pending';

  class RLExactFitCheck extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = readJSON(this, 'script[data-rlef-product]');
      this.form = this.closest('form');
      this.result = this.querySelector('[data-rlef-result]');
      this.property = this.querySelector('[data-rlef-property]');
      this.imageProperty = this.querySelector('[data-rlef-image-property]');
      this.confirmed = null;
      this.touched = false;
      if (!this.data || !this.form) return;
      this.combo = new Combo(this, {
        dataUrl: this.getAttribute('data-data-url'),
        emptyText: T('keine_rolle_produkt', 'Keine Rolle gefunden. Prüf die Schreibweise oder wähl deine Lagergröße unten.'),
        dotFor: this.dotFor.bind(this),
        onSelect: this.apply.bind(this),
        onReset: this.clearConfirmation.bind(this)
      });
      this.form.addEventListener('change', this.onFormChange.bind(this));
      document.addEventListener('submit', this.onSubmit.bind(this), true);
      if (!this.restorePending()) this.restoreFromUrl();
    }

    // Punkt in der Liste: unsere Empfehlung (nur wenn die Klasse die Größe hat)
    dotFor(entry) {
      if (!entry.rt) return '';
      var cls = this.classFor(entry.rt);
      if (!cls) return '';
      var fits = cls.variants.some(function (v) { return v.sk === entry.k; });
      if (!fits) return '';
      var text = T('empfehlung', 'Unsere Empfehlung:') + ' ' + cls.tier;
      return '<span class="rlef-dot" data-class="' + esc(entry.rt) + '" role="img" title="' + esc(text) + '" aria-label="' + esc(text) + '"></span>';
    }

    classFor(tier) {
      var all = [{ tier: this.data.tier, url: this.data.url, variants: this.data.variants }].concat(this.data.siblings || []);
      return all.filter(function (c) { return lower(c.tier) === tier; })[0] || null;
    }

    restoreFromUrl() {
      var self = this;
      var params = new URLSearchParams(window.location.search);
      var handle = params.get('rolle') || params.get('reel');
      if (!handle || !this.combo || !this.combo.input) return;
      this.combo.ensureData().then(function (reels) {
        if (!reels) return;
        var reel = reels.filter(function (item) { return item.h === handle; })[0];
        if (!reel) return;
        self.combo.setValue(reel.label);
        self.apply(reelEntry(reel, null), { fromUrl: true });
      });
    }

    idInput() {
      return this.form.querySelector('[name="id"]');
    }

    variantById(id) {
      return this.data.variants.filter(function (variant) { return String(variant.id) === String(id); })[0];
    }

    checkedValue(position) {
      if (!position) return null;
      var input = this.form.querySelector('input[name="option' + position + '"]:checked');
      if (input) return input.value;
      var select = this.form.querySelector('select[name="option' + position + '"]');
      return select ? select.value : null;
    }

    radioFor(position, value) {
      return Array.prototype.slice
        .call(this.form.querySelectorAll('input[name="option' + position + '"]'))
        .filter(function (input) { return input.value === value; })[0];
    }

    apply(entry, opts) {
      var self = this;
      var data = this.data;
      var matches = data.variants.filter(function (variant) { return variant.sk === entry.k; });
      if (!matches.length) {
        this.clearConfirmation();
        this.showUnavailable(entry);
        return;
      }
      // Abdeckung (Edge): Wahl des Kunden behalten, sonst die der URL-Variante
      var seal = this.checkedValue(data.sealPosition);
      var target = matches.filter(function (variant) { return !seal || variant.seal === seal; })[0] || matches[0];
      var radio = this.radioFor(data.sizePosition, target.size);
      this.touched = true;
      if (!radio || !this.idInput()) {
        this.reload(target, entry);
        return;
      }
      // Erst bestätigen, dann klicken: der Klick löst "change" aus, und onFormChange darf die
      // neue Auswahl nicht für eine Handänderung halten.
      this.confirm(target, entry);
      // Nitro übernimmt Variante, Preis, Adresse und Kaufleiste beim Klick auf das Optionsfeld
      if (!radio.checked) radio.click();
      setTimeout(function () {
        if (!self.confirmed || self.confirmed.id !== target.id) return;
        if (self.checkedValue(data.sizePosition) !== target.size) {
          self.reload(target, entry);
          return;
        }
        var field = self.idInput();
        var resolved = self.resolveVariantId();
        if (field && resolved && String(field.value) !== String(resolved)) field.value = resolved;
      }, 1200);
    }

    resolveVariantId() {
      var data = this.data;
      var size = this.checkedValue(data.sizePosition);
      var seal = this.checkedValue(data.sealPosition);
      var hit = data.variants.filter(function (variant) {
        return variant.size === size && (!data.sealPosition || variant.seal === seal);
      })[0];
      return hit ? hit.id : null;
    }

    // Unsere Empfehlung aus Sicht dieser Produktseite
    pickInfo(entry) {
      if (!entry.rt) return null;
      if (lower(this.data.tier) === entry.rt) return { same: true };
      var sibling = this.classFor(entry.rt);
      if (!sibling || !sibling.url) return null;
      var variant = (sibling.variants || []).filter(function (item) { return item.sk === entry.k; })[0];
      if (!variant) return null;
      var url = sibling.url + '?variant=' + variant.id + (entry.handle ? '&rolle=' + encodeURIComponent(entry.handle) : '');
      return { same: false, tier: sibling.tier, url: url };
    }

    /* Galerie: die Klassenbilder werden gegen das Serienbild der Rolle getauscht (nur im Browser). */
    galleryNodes() {
      var nodes = document.querySelectorAll('img, source');
      return Array.prototype.filter.call(nodes, function (node) {
        if (node.closest('rl-exact-fit-check')) return false;
        var all = [node.getAttribute('src'), node.getAttribute('srcset'), node.getAttribute('data-src'), node.getAttribute('data-srcset')].join(' ');
        return GENERIC_RE.test(all);
      });
    }

    syncGallery(entry) {
      this.restoreGallery();
      if (!entry || !entry.series) return;
      var own = (Store.series || {})[entry.series];
      if (!own) return;
      var swapped = [];
      var pattern = new RegExp('[^\\s,"\']*' + GENERIC_RE.source + '[^\\s,"\']*', 'gi');
      this.galleryNodes().forEach(function (node) {
        ['src', 'srcset', 'data-src', 'data-srcset'].forEach(function (attr) {
          var value = node.getAttribute(attr);
          if (!value || !GENERIC_RE.test(value)) return;
          var next = value.replace(pattern, function (url) {
            var m = url.match(GENERIC_RE);
            if (!m) return url;
            var key = m[1] === 'edge' ? (m[2] === '-offen' ? 'edge_open' : 'edge_sealed') : m[1];
            var target = own[key];
            if (!target) return url;
            var base = target.split('?')[0];
            var version = (target.match(/[?&]v=(\d+)/) || [])[1];
            // nur die Breite übernehmen, Höhe und Zuschnitt weg: das Serienbild wird nie beschnitten
            var query = (url.split('?')[1] || '').split('&').filter(function (part) { return /^width=/.test(part); });
            if (version) query.push('v=' + version);
            return base + (query.length ? '?' + query.join('&') : '');
          });
          if (next !== value) {
            swapped.push({ node: node, attr: attr, value: value });
            node.setAttribute(attr, next);
          }
        });
      });
      this.swappedGallery = swapped;
    }

    restoreGallery() {
      (this.swappedGallery || []).forEach(function (item) {
        item.node.setAttribute(item.attr, item.value);
      });
      this.swappedGallery = [];
    }

    // Dateiname des Serienbilds für den Warenkorb (die Warenkorb-Snippets bauen daraus die Bild-URL)
    seriesFile(entry) {
      if (!entry || !entry.series) return '';
      var own = (Store.series || {})[entry.series];
      if (!own) return '';
      var key = lower(this.data.tier);
      if (key === 'edge') key = /^(offen|open|ouvert|öppen|nyitott|ανοιχτ)/i.test(this.checkedValue(this.data.sealPosition) || '') ? 'edge_open' : 'edge_sealed';
      return own[key] ? String(own[key]).split('?')[0].split('/').pop() : '';
    }

    syncImageProperty() {
      if (!this.imageProperty) return;
      var file = this.confirmed ? this.seriesFile(this.confirmed.entry) : '';
      this.imageProperty.value = file;
      this.imageProperty.disabled = !file;
    }

    confirm(variant, entry) {
      var pick = this.pickInfo(entry);
      this.confirmed = { id: variant.id, size: variant.size, reel: entry.title, entry: entry };
      this.syncGallery(entry);
      this.syncImageProperty();
      if (this.property) {
        this.property.value = entry.prop || entry.title;
        this.property.disabled = false;
      }
      var pin = '';
      if ((entry.p || entry.pSome) && this.data.pinUrl) {
        pin =
          '<p class="rlef-check__note">' +
          esc(entry.p ? T('pin_satz_rolle', 'Für diese Rolle brauchst du zum Lagertausch einen Pin Remover.') : T('pin_satz_versionen', 'Einige Versionen dieser Rolle brauchen zum Lagertausch einen Pin Remover.')) +
          ' <a href="' + esc(this.data.pinUrl) + '">' + esc(T('zum_pin', 'Zum Pin Remover')) + '</a></p>';
      }
      this.result.innerHTML =
        '<span class="rlef-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"></path></svg>' +
        esc(T('passt_exakt_kurz', 'Passt exakt')) + (pick && pick.same ? ' · ' + esc(T('unsere_empfehlung_klein', 'unsere Empfehlung')) : '') + '</span>' +
        '<p class="rlef-check__line">' + esc(T('ausgewaehlt_fuer', 'Ausgewählt für deine %s:').replace('%s', entry.title)) + ' <strong>' + esc(variant.size) + '</strong></p>' +
        (pick && !pick.same
          ? '<p class="rlef-check__note">' + esc(T('passt_empfehlen', 'Passt zu deiner Rolle. Für die %s empfehlen wir').replace('%s', entry.title)) + ' <a href="' + esc(pick.url) + '">' + esc(pick.tier) + '</a>.</p>'
          : '') +
        pin;
    }

    clearConfirmation() {
      this.confirmed = null;
      this.restoreGallery();
      this.syncImageProperty();
      if (this.property) {
        this.property.value = '';
        this.property.disabled = true;
      }
      if (this.result) this.result.innerHTML = '';
    }

    showUnavailable(entry) {
      var self = this;
      var options = (this.data.siblings || [])
        .map(function (sibling) {
          var variant = (sibling.variants || []).filter(function (item) { return item.sk === entry.k; })[0];
          if (!variant) return '';
          return '<a href="' + esc(sibling.url) + '?variant=' + esc(variant.id) + (entry.handle ? '&rolle=' + encodeURIComponent(entry.handle) : '') + '">' + esc(sibling.tier) + '</a>';
        })
        .filter(Boolean);
      if (options.length) {
        this.result.innerHTML =
          '<p class="rlef-check__line">' + esc(T('gibt_es_nicht', '%t gibt es für diese Rolle nicht (%s).').replace('%t', self.data.tier).replace('%s', entry.s)) + '</p>' +
          '<p class="rlef-check__note">' + esc(T('passend_fuer_rolle', 'Passend für deine Rolle:')) + ' ' + options.join(', ') + '</p>';
      } else {
        this.result.innerHTML = '<p class="rlef-check__line">' + esc(T('kein_set_kurz', 'Für diese Rolle haben wir noch kein passendes Set (%s).').replace('%s', entry.s)) + '</p>';
      }
    }

    reload(variant, entry) {
      try {
        sessionStorage.setItem(
          PENDING_KEY,
          JSON.stringify({
            product: this.data.id,
            variant: variant.id,
            entry: { title: entry.title, prop: entry.prop, s: entry.s, k: entry.k, p: entry.p, pSome: entry.pSome, rt: entry.rt, handle: entry.handle, series: entry.series }
          })
        );
      } catch (error) {
        /* privater Modus: die Seite lädt trotzdem mit der richtigen Variante */
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.location.href = url.toString();
    }

    restorePending() {
      var pending = null;
      try {
        pending = JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null');
        sessionStorage.removeItem(PENDING_KEY);
      } catch (error) {
        return false;
      }
      if (!pending || !pending.entry || String(pending.product) !== String(this.data.id)) return false;
      var idInput = this.idInput();
      var variant = this.variantById(pending.variant);
      if (!idInput || !variant || String(idInput.value) !== String(variant.id)) return false;
      var self = this;
      this.touched = true;
      if (this.combo) this.combo.setValue(pending.entry.title);
      // Serienbilder brauchen die Daten
      this.combo.ensureData().then(function () {
        self.confirm(variant, pending.entry);
      });
      return true;
    }

    onFormChange(event) {
      if (!this.confirmed) return;
      var target = event.target;
      if (!target || !target.name) return;
      // Edge: andere Abdeckung, anderes Bild im Warenkorb
      if (this.data.sealPosition && target.name === 'option' + this.data.sealPosition) {
        this.syncImageProperty();
        return;
      }
      if (target.name !== 'option' + this.data.sizePosition) return;
      // Größe von Hand geändert: keine Exact-Fit-Auswahl mehr
      if (target.value !== this.confirmed.size) {
        this.clearConfirmation();
        if (this.combo) this.combo.setValue('');
      }
    }

    onSubmit(event) {
      if (event.target !== this.form || !this.touched) return;
      var id = this.resolveVariantId();
      var field = this.idInput();
      if (id && field) field.value = id;
    }
  }

  if (!customElements.get('rl-exact-fit-check')) customElements.define('rl-exact-fit-check', RLExactFitCheck);
  if (!customElements.get('rl-exact-fit-card')) customElements.define('rl-exact-fit-card', RLExactFitCard);
  if (!customElements.get('rl-lagerfinder')) customElements.define('rl-lagerfinder', RLLagerfinder);

  window.RLExactFit = {
    analyse: analyse,
    prepareReel: prepareReel,
    parseSizes: parseSizes,
    describeVariant: describeVariant,
    displayName: displayName,
    sizesLine: sizesLine,
    load: Store.load.bind(Store),
    store: Store
  };
})();
